import React from "react";

type Props = React.HTMLAttributes<HTMLSpanElement> & {
	color?: "default" | "success" | "warning" | "danger";
};

export function Badge({ className = "", color = "default", ...props }: Props) {
	const base = "badge";
	const colorClass =
		color === "success"
			? "badge-success"
			: color === "warning"
			? "badge-warning"
			: color === "danger"
			? ""
			: "";
	return <span className={`${base} ${colorClass} ${className}`} {...props} />;
}
